import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currentDate: null,
    currentHSEDate: null
}

export const CurrentDateSlice = createSlice({
    name: 'EndDateSlice',
    initialState,
    reducers: {
        addCurrentDate: (state, action) => {
            state.currentDate = action.payload
        },
        addCurrentHSEDate: (state, action) => {
            state.currentHSEDate = action.payload
        }
    },
    extraReducers: {},
})
